import { Injectable } from '@angular/core';
import { StyleGroup } from '../models/new/style-group';

@Injectable({
	providedIn: 'root'
})
export class StyleGroupMapper {
	constructor() {}

	toStyleGroup(styleGroup: any) {
		return new StyleGroup({
			id: styleGroup.id,
			name: styleGroup.name
		});
	}
}
